import { InfoOutlineIcon } from '@chakra-ui/icons';

type WarningTextBoxProps = {
  content: string;
  full?: boolean;
};

type handleContentProps = {
  text: string;
};

export const WarningTextBox = ({
  content,
  full = false
}: WarningTextBoxProps) => {
  const handleContent = ({ text }: handleContentProps) => {
    const parts = text.split(/\{(.*?)\}/);

    return (
      <div>
        {parts.map((part, index) => {
          if (index % 2 === 0) {
            return (
              <span key={index}>
                {part.split(/@/).map((item, cont) => {
                  if (cont > 0) {
                    return (
                      <span key={cont}>
                        <br />
                        {item}
                      </span>
                    );
                  } else {
                    return <span key={cont}>{item}</span>;
                  }
                })}
              </span>
            );
          } else {
            return <strong key={index}>{part}</strong>;
          }
        })}
      </div>
    );
  };

  const processedContent = handleContent({ text: content });

  return (
    <div
      data-testid="warning-box"
      className={`tw-flex tw-items-center tw-gap-[18px] tw-w-full ${
        full ? 'tw-max-w-full' : 'tw-max-w-[905px]'
      } tw-p-[18px] tw-bg-gray-300 tw-rounded-lg tw-shadow-md`}
    >
      <InfoOutlineIcon w="20px" h="20px" bg="transparent" />
      <p className="tw-text-base tw-lg:text-lg tw-leading-6">
        {processedContent}
      </p>
    </div>
  );
};
